import NoDataComponent from "./NoDataComponent";

export default NoDataComponent;
